import * as Website from '../Config/Website.js';

const init = () => {
  const tabContainers = document.querySelectorAll('.js-tab');

  tabContainers.forEach(tabNav => {
    const tabBtns = tabNav.querySelectorAll('[role="tab"]');
    const tabContent = tabNav.nextElementSibling;

    if (!tabContent) return;

    const tabPanels = tabContent.querySelectorAll('[role="tabpanel"]');

    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const tabId = btn.dataset.tab;

        // タブボタンの状態を更新
        tabBtns.forEach(b => {
          b.classList.remove(Website.classList.act);
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add(Website.classList.act);
        btn.setAttribute('aria-selected', 'true');

        // タブパネルの表示を切り替え
        tabPanels.forEach(panel => {
          if (panel.dataset.panel === tabId) {
            panel.classList.add(Website.classList.act);
          } else {
            panel.classList.remove(Website.classList.act);
          }
        });
      });
    });
  });
};

export {
  init
};
